export default "__VITE_ASSET__IqRYQ91W__"